import React, { Component } from "react";
import { Link } from "react-router-dom";
import request from "../../lib/requester";
import Autocomplete from "../../component/autocomplete";
import axios from "axios";
import _ from "lodash";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import moment from "moment";

class Member extends Component {
  constructor(props) {
    super(props);
    this.state = {
      org_initial: "",
      lovProgramMember: [],
      org_id: "",
      pphRate: "",
      pphType: "",
      programNumber: "",
      startDate: new Date(),
      endDate: new Date(),
      expDate: new Date(),
      ref_number: "",
      principalName: "",
      description: "",
      programType: "",
      budgetType: "",
      budget: 0,
      salesTarget: 0,
      programMember: "",
      totalParticipant: "",
      error: [],
      lovBranch: [],
      suggestions: [],
      selectedBranch: [],
      lovDocument: [],
      value: "",
      memberId: "",
      memberType: "",
      branchId: "",
      autocomplete: "",
      participant: { customer_id: null, participant: null },
      showParticipant: true,
      showCabang: true,
      programId: "",
      success: "",
      productList: [{ productName: "", productId: "" }],
      documentList: [],
      notes: "",
      attachment: [],
      lovBudget: [],
      lovProgramType: [],
      lovPPH: [],
      docContainer: [],
      oriParticipant: "",
      fileContainer: {},
      is_update: false,
      user: JSON.parse(window.localStorage.getItem("is_user")),
      submitteddate: "",
      h_name: "",
      h_npwp: "",
      h_address: "",
    };
  }

  componentDidMount = () => {
    window.localStorage.removeItem("is_token");
    window.localStorage.removeItem("is_user");
    let { id } = this.props.match.params;
    let param = {
      id: id,
    };
    this.setState({ programId: this.props.match.params.id, loading: true });
    request.postArman("/arman/v1/auth/dummylogin", param, {
      success: function (response) {
        // let { token } = response.data;
        let token = response.data.data.access_token;
        if (token.length > 0) {
          let currentToken = window.localStorage.getItem("is_token");
          this.setState({ loading: false });
          if (!currentToken) {
            window.localStorage.setItem("is_token", token);
          }
          let app = this;
          this.getPPHType();
          this.getBudgetType();
          this.getProgramMember();
          this.getDetailProgram();
          //   window.setTimeout(() => {
          //     // this.getDocumentList()
          //     app.getProgramMember();
          //     app.getBranch();
          //     app.getDetailProgram();
          //     app.getProgramType();
          //     app.getBudgetType();
          //   }, 100);
        } else {
          alert("Invalid Token");
          this.props.history.push("/login");
        }
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  getDetailProgram = () => {
    let url = "/api/traces/v1/program/detail";
    let { id } = this.props.match.params;
    let param = {
      program_id: id,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let { header, docs, attachment, product } = response.data.data;
        console.log(header);
        this.setState({
          org_initial: header.org_initial,
          org_id: header.org_id,
          programNumber: header.program_number,
          principalName: header.org_name,
          loading: false,
          pphType: header.pph_type,
          pphRate: header.pph_rate,
          ref_number: header.ref_number,
          description: header.description,
          startDate: new Date(header.start_date),
          endDate: new Date(header.end_date),
          expDate: new Date(header.claim_exp_date),
          programType: header.program_type_id,
          budgetType: header.budget_type_id,
          programMember: header.program_member_id,
          budget: header.budget,
          salesTarget: header.sales_target,
          totalParticipant: header.total_participant,
          notes: header.notes,
          docContainer: docs,
          is_update: header.status === "P" ? true : false,
          fileContainer: attachment,
          productList: product,
          submitteddate: moment(header.creation_date).format("DD-MMM-YYYY"),
        });
        this.getProgramType();
        this.getDocumentList();
      }.bind(this),
      error: function (e) {
        console.log(e);
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  getProgramMember = () => {
    let url = "/api/traces/v1/general/member-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovProgramMember: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getProgramType = () => {
    let url = "/api/traces/v1/general/program-type?orgId=" + this.state.org_id;
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovProgramType: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getBudgetType = () => {
    let url = "/api/traces/v1/general/budget-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovBudget: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  //   getBranch = () => {
  //     let url = "/branch";
  //     request.getOracle(url, {
  //       success: function (response) {
  //         this.setState({ lovBranch: response.data });
  //       }.bind(this),
  //       error: function (e) {
  //         console.log(e);
  //       },
  //     });
  //   };

  getDocumentList = () => {
    let url = "/api/traces/v1/general/document-list?orgId=" + this.state.org_id;
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovDocument: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  handleInputProduct = (e) => {
    let index = e.target.attributes.getNamedItem("data-index").value;
    let { productList } = this.state;
    productList[index].productName = e.target.value;
    this.setState(productList);
  };

  customerInfo = () => {
    // console.log(this.state.productList);
    return (
      <div className="row">
        <div className="col-md-6">
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Customer
            </label>
            <div className="col-sm-6">
              <input
                type="text"
                autoComplete="off"
                disabled
                className="form-control"
                id="inputEmail3"
                name="refNumber"
                // placeholder="Skp"
                // onChange={this.handleChangeInput.bind(this)}
                value={this.state.h_name}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Address
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                autoComplete="off"
                disabled
                className="form-control"
                id="inputEmail3"
                name="refNumber"
                // placeholder="Skp"
                // onChange={this.handleChangeInput.bind(this)}
                value={this.state.h_address}
              />
            </div>
          </div>

          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              NPWP/ NIK
            </label>
            <div className="col-sm-5">
              <input
                type="text"
                autoComplete="off"
                disabled
                className="form-control"
                id="inputEmail3"
                name="refNumber"
                // placeholder="Skp"
                // onChange={this.handleChangeInput.bind(this)}
                value={this.state.h_npwp}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  renderProduct = () => {
    return this.state.productList.map((item, index) => (
      <div className="form-group row" key={index}>
        <div className="col-sm-10">
          <input
            type="text"
            autoComplete="off"
            className="form-control"
            data-index={index}
            placeholder="Search Product..."
            onChange={this.handleInputProduct.bind(this)}
            value={item.productName}
          />
        </div>
        <div className="col-sm-2">
          <button
            type="button"
            onClick={this.replicateProduct.bind(this)}
            className="btn btn-success"
          >
            +
          </button>{" "}
          &nbsp;
          <button
            type="button"
            onClick={() => {
              this.removeProduct(index);
            }}
            className="btn btn-danger"
          >
            -
          </button>
        </div>
      </div>
    ));
  };
  replicateProduct = () => {
    let { productList } = this.state;
    productList.push({ productName: "", productId: "" });
    this.setState(productList);
  };

  removeProduct = (index) => {
    if (this.state.productList.length === 1) {
      alert("You must have at least 1 product");
      return false;
    }
    let { productList } = this.state;
    productList.splice(index, 1);
    this.setState(productList);
  };

  setChecked = (item) => {
    let find = _.find(this.state.docContainer, function (o) {
      return o.document_id === item.document_id;
    });
    return find ? true : false;
  };

  renderDocument = () => {
    return this.state.lovDocument.map((item, index) => (
      <div className="col-md-4" key={index}>
        <div className="form-check">
          <input
            disabled
            className="form-check-input"
            defaultChecked={this.setChecked(item)}
            type="checkbox"
            value={item.document_id}
            onClick={this.handleClickDocument.bind(this)}
            id="defaultCheck1"
          />
          <label className="form-check-label" htmlFor="defaultCheck1">
            {item.document_name}
          </label>
        </div>
      </div>
    ));
  };

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;
    let { documentList } = this.state;
    if (is_checked) {
      documentList.push({ documentId: docId });
    } else {
      let getIndex = _.findIndex(documentList, function (o) {
        return parseInt(o.documentId) === parseInt(docId);
      });
      documentList.splice(getIndex, 1);
    }
    this.setState(documentList);
  };

  replicateDocument = () => {
    let { documentList } = this.state;
    documentList.push({ documentName: "", documentId: "" });
    this.setState(documentList);
  };

  removeDocument = (index) => {
    if (this.state.documentList.length === 1) {
      alert("You must have at least 1 document");
      return false;
    }
    let { documentList } = this.state;
    documentList.splice(index, 1);
    this.setState(documentList);
  };

  handleInputDocument = (e) => {
    let index = e.target.attributes.getNamedItem("data-index").value;
    let { documentList } = this.state;
    documentList[index].documentName = e.target.value;
    this.setState(documentList);
  };

  renderLovBudget = () => {
    return (
      <select
        className="form-control"
        disabled
        name="budgetType"
        value={this.state.budgetType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Budget -</option>
        {this.state.lovBudget.map((item, index) => (
          <option value={item.budget_type_id} key={index}>
            {item.budget_type}
          </option>
        ))}
      </select>
    );
  };

  renderLovProgram = () => {
    return (
      <select
        className="form-control"
        disabled
        name="programType"
        value={this.state.programType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Program -</option>
        {this.state.lovProgramType.map((item, index) => (
          <option value={item.prog_type_id} key={index}>
            {item.program_name}
          </option>
        ))}
      </select>
    );
  };

  renderLovProgramMember = () => {
    return (
      <select
        className="form-control"
        disabled
        name="programMember"
        value={this.state.programMember}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Participants -</option>
        {this.state.lovProgramMember.map((item, index) => (
          <option value={item.program_member_id} key={index}>
            {item.description}
          </option>
        ))}
      </select>
    );
  };

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    this.setState({ [name]: value });
    window.setTimeout(() => {
      console.log(this.state);
    }, 100);
  };

  handleStartDate = (date) => {
    this.setState({ startDate: date });
  };

  handleEndDate = (date) => {
    this.setState({ endDate: date });
  };

  handleExpDate = (date) => {
    this.setState({ expDate: date });
  };

  resetForm = () => {
    this.setState({
      description: "",
      start_date: new Date(),
      end_date: new Date(),
      claim_exp_date: new Date(),
      program_type_id: "",
      budget_type_id: "",
      budget: 0,
      sales_target: 0,
      program_member_id: "",
      total_participant: "",
      notes: "",
      document_list: [],
    });
  };

  validationForm = () => {
    let count = 0;
    this.setState({ error: [], success: "" });
    if (this.state.principalName === "") {
      ++count;
    } else if (this.state.programType === "") {
      ++count;
    } else if (this.state.budgetType === "") {
      ++count;
    } else if (this.state.budget === 0 || this.state.budget === "") {
      ++count;
    } else if (this.state.salesTarget === 0 || this.state.salesTarget === "") {
      ++count;
    } else if (this.state.programMember === "") {
      ++count;
    } else if (
      this.state.totalParticipant === 0 ||
      this.state.totalParticipant === ""
    ) {
      ++count;
    } else if (this.state.documentList.length === 0) {
      ++count;
    }

    if (count > 0) {
      this.setState({
        error: [
          "The information you entered is incomplete, please check again",
        ],
      });
      window.scrollTo(0, 0);
      return false;
    } else {
      return true;
    }
  };

  handleApprove = () => {
    let url = "/arman/v1/general/get-approver";
    let { id } = this.props.match.params;
    let param = {
      principal_code: this.state.org_initial,
      program_id: id,
    };
    this.setState({ loading: true });
    request.postArman(url, param, {
      success: function (response) {
        let approver = response.data.data.map((item, index) => {
          return item.uid;
        });
        this.handleRequestUpdate("A", approver);
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  handleReject = () => {
    this.handleRequestUpdate("R");
  };

  handleRequestUpdate = (status, approver) => {
    let url = "/api/traces/v1/program/approve";
    let { id } = this.props.match.params;
    let param = {
      program_id: id,
      status: status,
      notes: this.state.notes,
      approver: approver,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let { message } = response.data;
        window.scrollTo(0, 0);
        this.setState({ loading: false, success: message });
        let app = this;
        window.setTimeout(() => {
          app.props.history.push("/admin/program/approval");
        }, 2000);
      }.bind(this),
      error: function (e) {
        window.scrollTo(0, 0);
        let error = e.response
          ? e.response.data.message
          : "Failed to approve program";
        this.setState({ loading: false, error: [error] });
      }.bind(this),
    });
  };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          {this.state.success}
        </div>
      );
    }
  };

  renderButton = () => {
    if (this.state.is_update) {
      return (
        <div className="col-sm-8">
          <button
            className="btn btn-success"
            onClick={this.handleApprove.bind(this)}
          >
            Approve
          </button>
          &nbsp;
          <button
            className="btn btn-danger"
            onClick={this.handleReject.bind(this)}
          >
            Reject
          </button>
          &nbsp;
          <button
            className="btn btn-warning"
            onClick={this.handleCancel.bind(this)}
          >
            Cancel
          </button>
        </div>
      );
    } else {
      return (
        <div className="col-sm-8">
          <button
            className="btn btn-warning"
            onClick={this.handleCancel.bind(this)}
          >
            Cancel
          </button>
        </div>
      );
    }
  };

  handleCancel = () => {
    this.props.history.push("/admin/program/summary");
  };

  renderProductList = () => {
    return (
      <table className="table table-striped table-sm table-bordered">
        <tr className="table-primary">
          <th>Product Description</th>
          <th>Product Reff</th>
          <th>Product Budget</th>
        </tr>
        {this.state.productList.map((item, index) => (
          <tr>
            <td>{item.item_description}</td>
            <td>{item.item_reff}</td>
            <td>{item.item_budget}</td>
          </tr>
        ))}
      </table>
    );
  };

  renderLovPPh = () => {
    return (
      <select
        disabled
        className="form-control"
        name="pphType"
        value={this.state.pphType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Type -</option>
        {this.state.lovPPH.map((item, index) => (
          <option value={item.pph_type} key={index}>
            {item.pph_type}
          </option>
        ))}
      </select>
    );
  };

  getPPHType = () => {
    let url = "/api/traces/v1/general/pph-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovPPH: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  renderLovProgramMember = () => {
    return (
      <select
        className="form-control"
        disabled
        name="programMember"
        value={this.state.programMember}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Participants -</option>
        {this.state.lovProgramMember.map((item, index) => (
          <option value={item.program_member_id} key={index}>
            {item.description}
          </option>
        ))}
      </select>
    );
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  {/* <div className="card-header">Form</div> */}
                  <div className="card-body">
                    {this.showSuccess()}
                    {this.showError()}
                    {/* <form className="form-horizontal"> */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Program Number
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              autoComplete="off"
                              disabled
                              className="form-control"
                              id="inputEmail3"
                              name="principalName"
                              placeholder="Principal"
                              onChange={this.handleChangeInput.bind(this)}
                              value={this.state.programNumber}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Principal
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              autoComplete="off"
                              disabled
                              className="form-control"
                              id="inputEmail3"
                              name="principalName"
                              placeholder="Principal"
                              onChange={this.handleChangeInput.bind(this)}
                              value={this.state.principalName}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Reff Number / SKP
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              autoComplete="off"
                              disabled
                              className="form-control"
                              id="inputEmail3"
                              name="ref_number"
                              placeholder="Reference Number"
                              onChange={this.handleChangeInput.bind(this)}
                              value={this.state.ref_number}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Program Type
                          </label>
                          <div className="col-sm-8">
                            {this.renderLovProgram()}
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Program Descriptions
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              autoComplete="off"
                              disabled
                              className="form-control"
                              id="inputEmail3"
                              name="description"
                              placeholder="Description"
                              onChange={this.handleChangeInput.bind(this)}
                              value={this.state.description}
                            />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Budget Type
                          </label>
                          <div className="col-sm-8">
                            {this.renderLovBudget()}
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Submitted Date
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              disabled
                              autoComplete="off"
                              className="form-control"
                              id="inputEmail3"
                              name="submitteddate"
                              value={this.state.submitteddate}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Start Date
                          </label>
                          <div className="col-sm-3">
                            <DatePicker
                              selected={this.state.startDate}
                              dateFormat="d-MMM-yyyy"
                              className="form-control"
                              popperPlacement="top-end"
                              onChange={this.handleStartDate}
                              disabled
                            />
                          </div>
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-2 col-form-label"
                          >
                            End Date
                          </label>
                          <div className="col-sm-3">
                            <DatePicker
                              selected={this.state.endDate}
                              dateFormat="d-MMM-yyyy"
                              className="form-control"
                              popperPlacement="top-end"
                              onChange={this.handleEndDate}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Claim Exp Date
                          </label>
                          <div className="col-sm-8">
                            <DatePicker
                              selected={this.state.expDate}
                              dateFormat="d-MMM-yyyy"
                              className="form-control"
                              popperPlacement="top-end"
                              onChange={this.handleExpDate}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Budget
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              disabled
                              autoComplete="off"
                              className="form-control"
                              id="inputEmail3"
                              placeholder="Budget"
                              name="budget"
                              onChange={this.handleChangeInput.bind(this)}
                              value={this.state.budget.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Sales Target
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              disabled
                              autoComplete="off"
                              className="form-control"
                              id="inputEmail3"
                              placeholder="Sales Target"
                              name="salesTarget"
                              onChange={this.handleChangeInput.bind(this)}
                              value={this.state.salesTarget.toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Customer PPh Type
                          </label>
                          <div className="col-sm-8">{this.renderLovPPh()}</div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            PPh Rate (%)
                          </label>
                          <div className="col-sm-4">
                            <input
                              disabled
                              type="number"
                              max="100"
                              min="0"
                              autoComplete="off"
                              className="form-control"
                              id="inputEmail3"
                              placeholder=""
                              name="pphRate"
                              onChange={this.handleChangeInput.bind(this)}
                              value={this.state.pphRate}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    {/* <div className="row">
                      <div className="col-md-12">
                        <h5>Customer Info</h5>
                        {this.customerInfo()}
                      </div>
                    </div>
                    <hr /> */}
                    <div className="row">
                      <div className="col-md-8">
                        <h5>Claim Documents</h5>
                        <div className="row">{this.renderDocument()}</div>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-md-6">
                        <h5>Participants</h5>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Participants Type
                          </label>
                          <div className="col-sm-8">
                            {this.renderLovProgramMember()}
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Total Participant
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="number"
                              disabled
                              className="form-control"
                              name="totalParticipant"
                              value={this.state.totalParticipant}
                              onChange={this.handleChangeInput.bind(this)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-md-6">
                        <h5>Products</h5>
                        {this.renderProductList()}
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Notes of Participants
                          </label>
                          <div className="col-sm-8">
                            <textarea
                              cols="10"
                              rows="5"
                              className="form-control"
                              value={this.state.notes}
                              disabled
                              name="notes"
                              onChange={this.handleChangeInput.bind(this)}
                            ></textarea>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          ></label>
                          <div className="col-md-9">
                            {/* <button className="btn btn-warning" onClick={ this.handleCancel.bind(this) }>Back</button> */}
                            {/* {this.renderButton()} */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        Files:
                        <br />
                        <Link
                          to={{ pathname: this.state.fileContainer.path }}
                          target="_blank"
                        >
                          {this.state.fileContainer.filename}
                        </Link>
                      </div>
                    </div>
                    {/* </form> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Member;
